<template>
  <transition name="pg-notification" @afterLeave="onAfterLeave" @afterEnter="onAfterEnter">
    <div
      class="pg-notification"
      :class="positionClass"
      :style="positionStyle"
      v-show="visible"
      @mouseleave="onMouseleave"
      @mouseenter="onMouseenter"
    >
      <i class="pg-notification__icon" :class="[iconClass]" v-if="iconClass"></i>
      <div class="pg-notification__right">
        <p class="pg-notification__right-top">
          <span class="pg-notification__right-tag" v-if="props.tag">{{ props.tag }}</span>
          <span class="pg-notification__right-title">{{ props.title }}{{ yOffset }}</span>
        </p>
        <p class="pg-notification__right-content">{{ props.content }}</p>
        <p class="pg-notification__right-btm" v-if="props.buttonText">
          <Link :underline="false" type="warning" @click="btnClick">{{ props.buttonText }}</Link>
        </p>
      </div>
      <i class="el-icon-close pg-notification__close" @click="onClose"></i>
    </div>
  </transition>
</template>
<script setup>
import { ref, reactive, getCurrentInstance, computed } from 'vue'
import { Link } from 'element-ui'

const { proxy } = getCurrentInstance()
const props = reactive({
  onAfterEnter: null,
  close: null,
  position: 'top-right', //top-right/top-left/bottom-right/bottom-left
  offset: 0,
  type: 'info', //success/warning/info/error
  tag: null,
  title: null,
  content: null,
  buttonText: null,
  onClick: null,
  duration: 4500,
})

const yOffset = ref(0)

const yProperty = computed(() => (~props.position.indexOf('top-') ? 'top' : 'bottom'))
const xProperty = computed(() => (~props.position.indexOf('-right') ? 'right' : 'left'))
const positionStyle = computed(() => ({
  [xProperty.value]: '20px',
  [yProperty.value]: `${yOffset.value}px`,
}))
const positionClass = computed(() => [`pg-notification--${props.type ?? 'default'}`])
const iconClass = computed(() => {
  if (!props.type) {
    return ''
  }
  switch (props.type) {
    case 'info':
      return 'ivu-icon-icon-pg-i'
    case 'success':
      return 'el-icon-circle-check'
    case 'warning':
      return 'el-icon-warning-outline'
    case 'error':
      return 'el-icon-circle-close'
    default:
      return ''
  }
})

const onAfterEnter = () => {
  props.onAfterEnter?.()
}

const btnClick = () => {
  props?.onClick?.()
}

const onAfterLeave = () => {
  proxy.$destroy(true)
  proxy.$el.parentNode.removeChild(proxy.$el)
}
//显示
const visible = ref(false)
const onClose = () => {
  visible.value = false
  props?.close()
}
let timer = null
const delayed = () => {
  if (props.duration > 0) {
    timer = setTimeout(() => {
      onClose()
    }, props.duration)
  }
}
const show = (options) => {
  Object.keys(options).forEach((op) => (props[op] = options[op]))
  visible.value = true
  delayed()
}

const onMouseleave = () => {
  delayed()
}

const onMouseenter = () => {
  if (timer) {
    clearTimeout(timer)
  }
}

defineExpose({
  yOffset,
  show,
  onClose,
})
</script>
<style lang="scss">
@import '../style/notification.scss';
</style>
